import { render, staticRenderFns } from "./mallDetail.vue?vue&type=template&id=ea78a2ae&scoped=true&"
import script from "./mallDetail.vue?vue&type=script&lang=js&"
export * from "./mallDetail.vue?vue&type=script&lang=js&"
import style0 from "./mallDetail.vue?vue&type=style&index=0&id=ea78a2ae&prod&lang=less&scoped=true&"
import style1 from "./mallDetail.vue?vue&type=style&index=1&id=ea78a2ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea78a2ae",
  null
  
)

export default component.exports